import React, { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import AnimateIn from './AnimateIn';
import courseData from '../../data/course.json';
import salesforceCourseImage from '../../images/salesforce-course.png';
import './Courses.css';

const Courses = ({ title, subtitle }) => {
  const navigate = useNavigate();
  const offerings = courseData.offerings || [];
  const coursesMap = courseData.courses || {};

  const list = useMemo(() => {
    return offerings.map((offering) => {
      const duration =
        offering.type === 'direct' && coursesMap[offering.courseSlug]?.stats?.duration
          ? coursesMap[offering.courseSlug].stats.duration
          : offering.type === 'category'
            ? 'Multiple tracks'
            : '—';
      const level =
        offering.type === 'direct' && coursesMap[offering.courseSlug]?.stats?.level
          ? coursesMap[offering.courseSlug].stats.level
          : offering.type === 'category'
            ? 'All levels'
            : '—';
      const imageUrl =
        offering.id === 'salesforce'
          ? salesforceCourseImage
          : offering.imageUrl || '';

      return {
        id: offering.id,
        title: offering.title,
        description: offering.description || '',
        imageUrl,
        duration,
        level,
        offering,
      };
    });
  }, [offerings, coursesMap]);

  const [selectedIndex, setSelectedIndex] = useState(0);
  const [hoverIndex, setHoverIndex] = useState(null);
  const displayIndex = hoverIndex !== null ? hoverIndex : selectedIndex;
  const selected = list[displayIndex];

  const handleClick = (offering) => {
    if (offering.type === 'direct') {
      navigate(`/course/${offering.courseSlug}`);
    } else {
      navigate(`/offerings/${offering.id}`);
    }
  };

  if (list.length === 0) return null;

  return (
    <section className="courses" id="courses">
      <div className="courses-container">
        <AnimateIn direction="up">
          <h2 className="courses-title">{title || 'Our Courses'}</h2>
          {subtitle && <p className="courses-subtitle">{subtitle}</p>}
        </AnimateIn>
        <div className="courses-bento">
          <div className="courses-bento-main">
            <div key={displayIndex} className="course-detail-panel course-card course-card-featured">
              <span className="course-card-accent" aria-hidden="true" />
              <div className="course-card-featured-inner">
                <div className="course-image-wrap">
                  <img src={selected.imageUrl} alt={selected.title} className="course-image" loading="lazy" />
                </div>
                <div className="course-body">
                  <span className="course-meta-top">{selected.duration} · {selected.level}</span>
                  <h3 className="course-card-title">{selected.title}</h3>
                  <p className="course-description">{selected.description}</p>
                  <button
                    type="button"
                    className="course-cta"
                    onClick={() => handleClick(selected.offering)}
                  >
                    Learn more
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="courses-bento-side">
            {list.map((item, i) => (
              <button
                key={item.id}
                type="button"
                className={`course-tab ${i === displayIndex ? 'course-tab-active' : ''}`}
                onClick={() => setSelectedIndex(i)}
                onMouseEnter={() => setHoverIndex(i)}
                onMouseLeave={() => {
                  setSelectedIndex(i);
                  setHoverIndex(null);
                }}
                aria-pressed={i === selectedIndex}
                aria-label={`Show ${item.title}`}
              >
                <span className="course-tab-thumb">
                  <img src={item.imageUrl} alt="" loading="lazy" />
                </span>
                <span className="course-tab-content">
                  <span className="course-tab-meta">{item.duration} · {item.level}</span>
                  <span className="course-tab-title">{item.title}</span>
                </span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Courses;
